export default __webpack_public_path__ + "static/media/us.15b26b29.webp";